import { Await } from "react-router";
import CustomError from "@components/Error/CustomError";
import EventsAwardsGalleryYearPageContent from "@events-awards/EventsAwardsGalleryYearPageContent";
import {
  EventsAwardsGalleryContextData,
  EventsAwardsPageContext,
} from "@events-awards/utils/types";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

export default function EventsAwardsGalleryYearPage(): React.ReactElement {
  const { context } =
    useRouteContext<
      TRouteWithRedirect<
        EventsAwardsPageContext<EventsAwardsGalleryContextData>,
        string
      >
    >();

  if (context && context.statusCode !== HttpStatusCode.Ok) {
    // StatusCode is not 200
    return <CustomError statusCode={context.statusCode} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }) => {
        if (kind !== "section") {
          // Error or kind is not "section"
          return <CustomError statusCode={context.statusCode} />;
        }

        // StatusCode is 200 and kind is "section"
        return <EventsAwardsGalleryYearPageContent {...data} />;
      }}
    </Await>
  );
}
